import merge from "lodash/merge";
import type { VariableOptionType } from "../enum/VariableOptionType";
import type { VariableOption } from "../interfaces/VariableOption";

type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const createVariableOption = <T extends VariableOption>(
  type: VariableOptionType,
  values: Omit<T, keyof VariableOption>,
): T => {
  return merge(
    {
      uuid: crypto.randomUUID(),
      variableOptionType: type,
    },
    values,
  ) as unknown as T;
};
